import { S } from '../game/state';
import { parseOSM } from './osm';
import { overpassQuery, OVERPASS_ENDPOINTS, MIN_BUILDINGS } from './query';
import { apiUrl } from '../net/client';
export { overpassQuery } from './query';

export function idb(){ return new Promise<IDBDatabase>((res, rej) => { const r = indexedDB.open('polarize', 1); r.onupgradeneeded = () => r.result.createObjectStore('maps'); r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error); }); }
export async function cacheGet(k){ try { const db = await idb(); return await new Promise((res,rej)=>{ const t = db.transaction('maps').objectStore('maps').get(k); t.onsuccess=()=>res(t.result||null); t.onerror=()=>rej(t.error); }); } catch(e){ return null; } }
export async function cachePut(k, v){ try { const db = await idb(); await new Promise((res,rej)=>{ const t = db.transaction('maps','readwrite').objectStore('maps').put(v, k); t.onsuccess=res; t.onerror=()=>rej(t.error); }); } catch(e){} }

class TooFew extends Error {}
function accept(j: any, lat, lon, half){
  const parsed = parseOSM(j, lat, lon, half);
  if (parsed.buildings.length < MIN_BUILDINGS) throw new TooFew(`only ${parsed.buildings.length} building${parsed.buildings.length === 1 ? '' : 's'} mapped in this box — pick a denser spot`);
  return parsed;
}
const reason = (e: any) => e?.name === 'AbortError' ? 'timed out' : (e?.message || String(e));

export async function fetchOSM(key, lat, lon, half, log){
  const ck = `${key}:${lat.toFixed(4)},${lon.toFixed(4)},${half}`;
  // 1. baked file next to the page (maps/<key>.json from bake_maps.py)
  if (!key.startsWith('custom')){ try { log('checking baked map'); const r = await fetch(`maps/${key}.json`, {cache:'force-cache'}); if (r.ok){ const j: any = await r.json(); if (j && j.elements) { S.citySource = 'baked'; return parseOSM(j, lat, lon, half); } } } catch(e){} }
  // 2. local cache
  const cached = await cacheGet(ck); if (cached){ S.citySource = 'cached'; return accept(cached, lat, lon, half); }
  let lastErr: any = null;
  // 3. the polarize server: one Overpass hit per spot per day, cached at the edge and shared with the city room
  try {
    log('asking the polarize server');
    const ctrl = new AbortController(); const t = setTimeout(()=>ctrl.abort(), 60000);
    const r = await fetch(apiUrl(`/api/osm?lat=${lat}&lon=${lon}&half=${half}`), {signal:ctrl.signal}); clearTimeout(t);
    const ct = r.headers.get('content-type') || '';
    if (r.ok && ct.includes('json')){ const j: any = await r.json(); if (j && j.elements){ const parsed = accept(j, lat, lon, half); cachePut(ck, j); S.citySource = 'osm'; return parsed; } throw new Error(j?.error || 'bad answer'); }
    let msg = `server answered ${r.status}`; try { if (ct.includes('json')) msg = (await r.json() as any).error || msg; } catch(e){}
    throw new Error(msg);
  } catch(e){ if (e instanceof TooFew) throw e; lastErr = e; log(`server: ${reason(e)}`); }
  // 4. live Overpass, straight from the browser
  const q = overpassQuery(lat, lon, half);
  for (const ep of OVERPASS_ENDPOINTS){
    const host = new URL(ep).host;
    try {
      log(`querying ${host}`);
      const ctrl = new AbortController(); const t = setTimeout(()=>ctrl.abort(), 45000);
      const r = await fetch(ep, {method:'POST', headers:{'Content-Type':'application/x-www-form-urlencoded'}, body:'data='+encodeURIComponent(q), signal:ctrl.signal});
      clearTimeout(t);
      if (!r.ok) throw new Error(`${host} answered ${r.status}`);
      const j: any = await r.json();
      const parsed = accept(j, lat, lon, half);
      cachePut(ck, j); S.citySource = 'osm';
      return parsed;
    } catch(e){ if (e instanceof TooFew) throw e; lastErr = e; log(`${host}: ${reason(e)}`); }
  }
  throw new Error(lastErr ? reason(lastErr) : 'unreachable');
}
export function proceduralCity(){
  const out = {buildings:[], roads:[], parks:[], water:[], coast:[]};
  for (let gx=-6; gx<=6; gx++){ out.roads.push({pts:[[gx*62,-420],[gx*62,420]], type:gx%3===0?'primary':'residential'}); out.roads.push({pts:[[-420,gx*62],[420,gx*62]], type:gx%3===0?'secondary':'residential'}); }
  for (let gx=-6; gx<=6; gx++) for (let gz=-6; gz<=6; gz++){
    const cx = gx*62, cz = gz*62; const n = 1 + (Math.random()*3|0);
    for (let i=0;i<n;i++){
      const w = 14+Math.random()*24, d = 14+Math.random()*24;
      const ox = cx + (Math.random()-.5)*(50-w), oz = cz + (Math.random()-.5)*(50-d);
      const h = Math.random()<.15 ? 60+Math.random()*140 : 8+Math.random()*40;
      out.buildings.push({id:`p${gx+6}_${gz+6}_${i}`, pts:[[ox-w/2,oz-d/2],[ox+w/2,oz-d/2],[ox+w/2,oz+d/2],[ox-w/2,oz+d/2]], h, vol:w*d*h, tags:{}});
    }
  }
  return out;
}
